import React from 'react';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { connect } from 'react-redux';
import { errorDialogAction } from '../redux/actions/common';

const ErrorDialog = ({common, setErrorDialog}) => {
  
  const handleClose = () => {
    setErrorDialog({val : ''});
  };

  return (
    <div>
      <Dialog
        open={!!common.errorDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Alert severity="error">{common.errorDialog}</Alert>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapState = (state) => ({
  common: state.common
});

const mapActions = {
  setErrorDialog: errorDialogAction
};

export default connect(mapState, mapActions)(ErrorDialog);